import React from "react";
import { Card, DefaultLayout, PageHeaderImage } from "Components";
import { RefreshIcon } from "Components/RefreshIcon";
import { H3 } from "melodies-source/Text";
import { GlobalStyles } from "styled";
import styled from "styled-components";
import { useArtistEventContext } from "contexts/ArtistEventContext";
import { Info } from "./Info";
import { Entries } from "./Entries";
import { Activity } from "./Activity";
import { FanLocations } from "./FanLocations";
import { Impressions } from "./Impressions";
import { Clicks } from "./Clicks";
import { Results } from "./Results";
import { PostShowEmail } from "./PostShowEmail";
import { Sweepstakes } from "./Sweepstakes";
import { MultiDay } from "./MultiDay";
import { useMultiDayEventContext } from "contexts/MultiDayEventContext";

export const ShowDetails: React.FC = () => {
  const { event, eventLoading, votes, votesLoading, votesError } =
    useArtistEventContext();
  const { multidayEvent } = useMultiDayEventContext();
  const eventIsVersion2 = event?.version === 2;

  return (
    <DefaultLayout>
      <GlobalStyles grayBG />
      <PageHeaderImage app="live" />
      <Container>
        {!eventLoading && !event?._id ? (
          <ErrorCard isElevated>
            <H3>We couldn't load this show, please try again.</H3>
            <RefreshIcon />
          </ErrorCard>
        ) : (
          <>
            <Info />
            {!!multidayEvent && <MultiDay />}
            {eventIsVersion2 &&
              (Object.keys(votes ?? {}).length > 0 ||
                (!votesLoading && votesError)) && <Results />}
            <CardsContainer>
              {multidayEvent ? (
                <>
                  <Entries />
                  <FanLocations />
                </>
              ) : (
                <>
                  <Col>
                    <Entries />
                    <FanLocations />
                  </Col>
                  <Activity />
                </>
              )}
            </CardsContainer>
            {eventIsVersion2 && <Clicks />}
            {eventIsVersion2 && <PostShowEmail />}
            {eventIsVersion2 && (
              <CardsContainer>
                <Impressions />
                <Sweepstakes />
              </CardsContainer>
            )}
          </>
        )}
      </Container>
    </DefaultLayout>
  );
};

const ErrorCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
`;

const Col = styled.div`
  display: grid;
`;

const CardsContainer = styled.div`
  display: flex;
  gap: 30px;

  & > div {
    flex-basis: 50%;
  }

  ${({ theme }) => theme.media.mobile} {
    flex-wrap: wrap;
    gap: 0;

    & > div {
      flex-basis: 100%;
    }
  }
`;

const Container = styled.div`
  position: relative;
  padding: 37px 46px;
  font-family: "Poppins";

  ${({ theme }) => theme.media.mobile} {
    padding: 20px 0;
    width: 95%;
    margin-left: auto;
    margin-right: auto;
  }
`;
